import React from "react";
import ContentEditable from "../../../../Components/ContentEditable/ContentEditable";

function Pattern({
  headerHtml,
  resumeHandler,
  resumeUpdate,
  response,
  index,
  styles,
  sectionId,
  handleDatePicker,
}) {
  const { selectedFont, primaryColor, secondaryColor, titleFont, bodyFont } =
    styles;
  //Role
  const ExperienceRole = (
    resumeHandler,
    resumeUpdate,
    response,
    index,
    sectionId
  ) => {
    return (
      response &&
      response.showFields &&
      response.showFields.position && (
        <ContentEditable
          sectionId={sectionId}
          name="position"
          tagType="div"
          className=""
          index={index}
          value={response.position}
          placeholder="Role Title"
          onChange={resumeHandler}
          onBlur={resumeUpdate}
          style={{
            color: primaryColor,
            fontFamily: bodyFont,
            fontSize: selectedFont?.h3,
            lineHeight: selectedFont?.h3_lineHeight,
            fontWeight: 500,
            paddingBottom: "5px",
          }}
        />
      )
    );
  };

  //Company
  const ExperienceCompany = (response, index) => {
    return (
      response &&
      response.showFields &&
      response.showFields.company && (
        <ContentEditable
          sectionId={sectionId}
          name="company"
          tagType="span"
          className=""
          index={index}
          value={response.company}
          placeholder="Company Title"
          onChange={resumeHandler}
          onBlur={resumeUpdate}
          style={{
            color: secondaryColor,
            fontFamily: bodyFont,
            fontSize: selectedFont?.h4,
            lineHeight: selectedFont?.h4_lineHeight,
            fontWeight: 400,
          }}
        />
      )
    );
  };

  const ExperienceDate = (handleDatePicker, response, index) => {
    return (
      response &&
      response.showFields &&
      response.showFields.date && (
        <div className="d-flex" style={{ alignItems: "center" }}>
          <i
            class="fa fa-calendar"
            aria-hidden="true"
            style={{
              color: primaryColor,
              fontSize: selectedFont?.p2,
              lineHeight: "normal",
              paddingLeft: "6px",
            }}
          ></i>
          <span
            className="experience-from"
            data-placeholder="From"
            style={{
              color: primaryColor,
              fontFamily: bodyFont,
              fontSize: selectedFont?.p2,
              fontWeight: 400,
              lineHeight: "normal",
              paddingLeft: "6px",
            }}
            onClick={() => handleDatePicker("from")}
          >
            {response &&
            response.dateRange &&
            response.dateRange.fromYear &&
            response.dateRange.fromMonth
              ? `${response.dateRange.fromMonth} / ${response.dateRange.fromYear}`
              : response &&
                response.dateRange &&
                response.dateRange.fromYear &&
                response.dateRange.fromYear
              ? response.dateRange.fromYear
              : ""}
          </span>
          <span
            style={{
              color: primaryColor,
              fontFamily: bodyFont,
              fontSize: selectedFont?.p2,
              fontWeight: 400,
              lineHeight: "normal",
            }}
          >
            {" "}
            -{" "}
          </span>
          <span
            data-placeholder="To"
            style={{
              color: primaryColor,
              fontFamily: bodyFont,
              fontSize: selectedFont?.p2,
              fontWeight: 400,
              lineHeight: "normal",
            }}
            onClick={() => handleDatePicker("to")}
          >
            {response && response.dateRange && response.dateRange.isOnGoing
              ? response &&
                response.dateRange &&
                response.dateRange.onGoingText != ""
                ? response &&
                  response.dateRange &&
                  response.dateRange.onGoingText
                : "Ongoing"
              : response &&
                response.dateRange &&
                response.dateRange.toYear &&
                response &&
                response.dateRange &&
                response.dateRange.toMonth
              ? `${response.dateRange.toMonth} / ${response.dateRange.toYear}`
              : response && response.dateRange && response.dateRange.toYear
              ? response && response.dateRange && response.dateRange.toYear
              : ""}
          </span>
        </div>
      )
    );
  };

  const ExperienceLocation = (response, index) => {
    return (
      response &&
      response.showFields &&
      response.showFields.location && (
        <>
          <div
            className="d-flex"
            style={{ alignItems: "center", paddingLeft: "4px" }}
          >
            <i
              class="fa fa-thumb-tack"
              aria-hidden="true"
              style={{
                color: primaryColor,
                fontSize: selectedFont?.p2,
                lineHeight: "normal",
                paddingLeft: "6px",
              }}
            ></i>
            <ContentEditable
              sectionId={sectionId}
              name="location"
              tagType="span"
              className="experience-location"
              index={index}
              value={response.location}
              placeholder="Location"
              onChange={resumeHandler}
              onBlur={resumeUpdate}
              style={{
                color: primaryColor,
                fontFamily: bodyFont,
                fontSize: selectedFont?.p2,
                fontWeight: 400,
                lineHeight: "normal",
                paddingLeft: "6px",
              }}
            />
          </div>
        </>
      )
    );
  };

  return (
    <div>
      {headerHtml == "Header1" ? (
        <>
          <div>
            {ExperienceRole(
              resumeHandler,
              resumeUpdate,
              response,
              index,
              sectionId
            )}
          </div>
          <div
            className="d-flex justify-content-between"
            style={{ alignItems: "center", alignSelf: "stretch" }}
          >
            <div>{ExperienceCompany(response, index)}</div>
            <div>
              <div className="d-flex">
                <div className="mr-2">
                  {ExperienceDate(handleDatePicker, response, index)}
                </div>
                <div>{ExperienceLocation(response, index)}</div>
              </div>
            </div>
          </div>
        </>
      ) : headerHtml == "Header2" ? (
        <>
          <div>
            {ExperienceRole(
              resumeHandler,
              resumeUpdate,
              response,
              index,
              sectionId
            )}
          </div>
          <div
            className="d-flex justify-content-between"
            style={{ alignItems: "center", alignSelf: "stretch" }}
          >
            <div>{ExperienceCompany(response, index)}</div>
            <div>
              <div
                className="d-flex"
                style={{
                  justifyContent: "flex-end",
                  alignItems: "center",
                  alignSelf: "stretch",
                }}
              >
                <div className="">
                  {ExperienceDate(handleDatePicker, response, index)}
                </div>
                <div>{ExperienceLocation(response, index)}</div>
              </div>
            </div>
          </div>
        </>
      ) : (
        <>
          <div>
            {ExperienceRole(
              resumeHandler,
              resumeUpdate,
              response,
              index,
              sectionId
            )}
          </div>
        </>
      )}
    </div>
  );
}

export default Pattern;
